var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col pt-3 pb-3"},[_c('h1',[_vm._v("Page Not Found")])])])])
}]

export { render, staticRenderFns }